import React, { useEffect, useMemo } from 'react'
import { makeStyles } from '@material-ui/styles'
import Theme from 'core/themes/model'
import SectionHeader from 'core/components/SectionHeader'
import VolumeBackendCard from './VolumeBackendCard'
import { Blueprint } from 'openstack/components/infrastructure/blueprint/model'
import { keys } from 'ramda'

const useStyles = makeStyles<Theme>((theme) => ({
  accordionBody: {
    background: 'white',
    padding: 16,
  },
  volumeBackends: {
    marginTop: 16,
    display: 'grid',
    gap: 8,
  },
}))

interface BackendVolumeTypes {
  [Name: string]: any[] // volume
}

interface Backends {
  [Name: string]: BackendVolumeTypes
}

interface Props {
  blueprint: Blueprint
  volumeTypesByBackend: Backends
  volumeTypes: any[]
}

export default function VolumeBackends({ blueprint, volumeTypesByBackend, volumeTypes }: Props) {
  const classes = useStyles()

  const volumeBackends = useMemo(() => {
    const storageBackendKeys = keys(blueprint?.storageBackends)
    return storageBackendKeys?.reduce((accum, key) => {
      const storageBackend = blueprint.storageBackends[key] || {}
      const storageBackendConfigKeys = keys(storageBackend)
      return [
        ...accum,
        {
          name: key,
          configs: storageBackendConfigKeys.reduce((_accum, _key) => {
            return [
              ..._accum,
              {
                ...storageBackend[_key],
                name: _key,
              },
            ]
          }, []),
        },
      ]
    }, [])
  }, [blueprint])

  return (
    <div>
      <SectionHeader>Volume Backends Configured</SectionHeader>
      <div className={classes.volumeBackends}>
        {volumeBackends.map((volumeBackend, idx) => (
          <VolumeBackendCard
            key={idx}
            id={`backend-${idx}`}
            volumeBackend={volumeBackend}
            volumeTypesByBackend={volumeTypesByBackend}
            volumeTypes={volumeTypes}
          />
        ))}
      </div>
    </div>
  )
}
